import { subMinutes } from 'date-fns'

import { timeZoneOffset } from './constants'

export const getLocalDate = (date: Date | string) => {
  return subMinutes(date, timeZoneOffset)
}
